import { BlueButton, WhiteButton, YellowButton } from "../../Button/button";
import classes from "./popup.module.css";
import Edit from "../../../../assets/images/Onboarding/yellowEdit.svg";
import { useState } from "react";
import { Test } from "../../../../constants/svg";
import { useNavigate } from "react-router";

const Popup3 = ({ data, setData }) => {
  const [form, setForm] = useState(false);
  const navigate = useNavigate();

  return (
    <div className={classes.main}>
      <h4>Documents</h4>
      <hr />
      {data?.proofOfIdentity && (
        <div className={`flex ${classes.docs}`}>
          <Test />
          <a href={data?.proofOfIdentity} target="_blank" rel="noreferrer">
            Proof of Identity
          </a>
        </div>
      )}
      {data?.proofOfAddress && (
        <div className={`flex mt-sm ${classes.docs}`}>
          <Test />
          <a href={data?.proofOfAddress} target="_blank" rel="noreferrer">
            Proof of Address
          </a>
        </div>
      )}

      <hr />
      {!form && (
        <YellowButton extra={classes.edit} onClick={() => navigate("/talent-onboarding?stage=5")}>
          <img src={Edit} alt="Edit" /> Edit
        </YellowButton>
      )}
      {form && (
        <div className={`flex ${classes.btn}`}>
          <WhiteButton onClick={() => setForm(false)}>Cancel</WhiteButton>
          <BlueButton onClick={() => setForm(false)}>Save</BlueButton>
        </div>
      )}
    </div>
  );
};

export default Popup3;
